// components/AdminDashboard.js
import React, { useState } from 'react';
import AllJobs from './AllJobsPage';
import Applicants from './ApplicantsPage';
import Home from './AdminHome';
import './AdminDashboard.css';
import { LogOut } from 'lucide-react';
import { useNavigate } from 'react-router-dom';

function AdminDashboard({ onLogout }) {
  const [activeTab, setActiveTab] = useState('home');
  const [sidebarOpen, setSidebarOpen] = useState(true);
  const navigate = useNavigate()

  const handleLogout = () => {
    if (onLogout) onLogout(); // Call any passed-in logout logic (e.g., clearing auth)
    navigate('/admin'); // Redirect to /admin
  };

  const renderContent = () => {
    switch (activeTab) {
      case 'jobs':
        return <AllJobs />;
      case 'applicants':
        return <Applicants />;
      case 'home':
      default:
        return <Home setActiveTab={setActiveTab} />;
    }
  };

  return (
    <div className="admin-container">
      <div className="main-layout">
        {sidebarOpen && (
          <div className="admin-sidebar">
            <h3>Admin Panel</h3>
            <ul>
              <li
                className={activeTab === 'home' ? 'active' : ''}
                onClick={() => setActiveTab('home')}
              >
                Home
              </li>
              <li
                className={activeTab === 'jobs' ? 'active' : ''}
                onClick={() => setActiveTab('jobs')}
              >
                All Jobs
              </li>
              <li
                className={activeTab === 'applicants' ? 'active' : ''}
                onClick={() => setActiveTab('applicants')}
              >
                Applicants
              </li>
            </ul>
          </div>
        )}

        <div className="main-content">
          <div className="topbar">
            <button className="toggle-btn" onClick={() => setSidebarOpen(!sidebarOpen)}>☰</button>
            <button className="logout-btn" onClick={handleLogout}>
              <LogOut size={16} className="logout-icon" />
              <span>Logout</span>
            </button>
          </div>
          <div className="content-area">{renderContent()}</div>
        </div>
      </div>
    </div>
  );
}

export default AdminDashboard;
